import { Injectable } from "@angular/core";
import { environment } from "./../../environments/environment";

export enum Features {
  SERVICE_LINK = "service-link",
  TECH_UPDATE = "tech-update"
}
@Injectable({
  providedIn: "root"
})
export class FeatureService {
  constructor() {}

  // this should probably be logged from azure app config
  public isFeatureEnabled(feature: Features): boolean {
    return environment.features && environment.features.includes(feature.toString());
  }
}
